import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import it from './it';
import en from './en';

const savedLang = localStorage.getItem('lang') || 'it';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      it: { translation: it },
      en: { translation: en }
    },
    lng: 'it',          // lingua di default
    fallbackLng: 'en',  // se la lingua non è trovata
    interpolation: {
      escapeValue: false // React già fa escape
    }
  });

export default i18n;
